exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span{font-size:10px;font-weight:700;margin:1em 0;cursor:pointer}.Tip-module__tip___3spGu{position:absolute;width:284px;left:-9px;background:#fff;top:35px;box-shadow:0 0 15px rgba(0,0,0,.4);z-index:500}.Tip-module__tip___3spGu img{width:100%}.Tip-module__tip___3spGu p{margin:1em;color:#0088fe;font-size:12px}.Tip-module__tip___3spGu:before{content:\" \";height:0;position:absolute;width:0;top:-16px;right:15px;border:8px solid transparent;border-bottom-color:#fff}", ""]);

// exports
exports.locals = {
	"tip": "Tip-module__tip___3spGu"
};